import React from 'react'
import axios from 'axios'
import get from 'lodash.get'
import GatsbyConfig from '../../../gatsby-config.js'
import { getParamFromQueryString } from '../../utils/app-helpers'
import AddNights from '../partials/add-nights'
import HelmetWrapper from '../partials/helmet-wrapper'
import SiteFooter from '../partials/site-footer'
import SiteHeader from '../partials/site-header'
import YoureGoing from '../partials/youre-going'

const { siteMetadata: config } = GatsbyConfig
const defaultError = 'Unable to locate traveler information'

export default class AddNightsPage extends React.Component {
  componentDidMount() {
    const subscriptionId = getParamFromQueryString('sid', window.location.href)

    return axios
      .post(
        `${
          process.env.GATSBY_ENDPOINT_SUBSCRIPTION_DATA
        }?sid=${subscriptionId}`,
        { headers: config.axiosHeaders }
      )
      .then(this.subscriptionDataSuccess)
      .catch(this.subscriptionDataError)
  }

  subscriptionDataSuccess = res => {
    const tripData = config.trips[this.props.trip]
    let trip = get(res, 'data.trip')
    let room = get(res, 'data.room')

    // plan IDs for older subscriptions do not start with the
    // trip ID, so we check for that situation and set the
    // room to the "trip" value if the data matches
    if (!tripData.rooms[room] && tripData.rooms[trip]) {
      room = trip
    }

    if (res && res.data) {
      this.setState({
        subscriptionId: get(res, 'data.id'),
        bookData: {
          room,
          trip: this.props.trip,
          email: get(res, 'data.email'),
          primaryName: get(res, 'data.primaryName'),
          spouseName: get(res, 'data.spouseName'),
        },
      })
    } else {
      this.setState({ error: defaultError })
    }
  }

  subscriptionDataError = err => {
    const error = get(err, 'message', err || defaultError)
    this.setState({ error })
  }

  render() {
    const { trip } = this.props
    const { bookData, error, subscriptionId } = this.state || {}
    const tripData = config.trips[trip]
    const { room, primaryName, spouseName } = bookData || {}
    const roomData = room ? tripData.rooms[room] : {}
    const title = `Add Nights to your ${tripData.name} ${
      tripData.year
    } Love Song Getaway`
    const description = `Add nights to your Love Song Couples Getaway | ${
      tripData.name
    } ${tripData.year}`

    return (
      <div className={`page-add-nights trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader trip={trip} />
        <main>
          {!bookData && !error ? (
            <div className="loader-mask">
              <p>Loading Traveler Data</p>
              <div className="loader" />
            </div>
          ) : error ? (
            <div>
              <p className="error">{error}</p>
            </div>
          ) : (
            <div>
              <YoureGoing
                heading="Welcome Back!"
                message="It just got easier to add nights to your getaway, "
                trip={trip}
                name1={primaryName}
                name2={spouseName}
              />
              {subscriptionId && get(roomData, 'extraNightPrices.default') ? (
                <AddNights
                  trip={trip}
                  bookData={bookData}
                  subscriptionId={subscriptionId}
                />
              ) : (
                ''
              )}
              <div
                style={{
                  backgroundImage: `url(/images/trip-slider-${trip}-venue.jpg)`,
                }}
                className="image mobile-100x40 desktop-300"
              />
            </div>
          )}
        </main>
        <SiteFooter trip={trip} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/add-nights.js